import { axiosInstance } from "@/plugins/axios";
import {HSCodeAssociation} from "@/modules/hs_code_association/types";

export async function saveHSCodeAssociations(associations: HSCodeAssociation[]) {
  return await axiosInstance.post(`harmonized_system_code_associations/create_or_update_many`, {
    associations
  });
}

export async function deleteHSCodeAssociations(itemIds: number[]) {
  return await axiosInstance.post(`harmonized_system_code_associations/items`, {
    item_ids: itemIds
  });
}
